export const typeFaceObjs = [
  { label: '楷書体', value: 'serif', path: 'block' }, // 明朝体
  { label: 'ブラッシュ体', value: 'Brush Script MT', path: 'brush' },
  { label: '活字体', value: 'sans-serif', path: 'print' }, // ゴシック体
  { label: '特殊英字体', value: 'CloisterBlack', path: 'specialAlphabetic' },
  { label: '勘亭流体', value: 'kanteiStyle', path: 'kanteiStyle' },
  { label: 'アリーバ体', value: 'arriba', path: 'arriba' }
]
export const typeFaceJaObjs = typeFaceObjs.filter((t) => ['serif', 'kanteiStyle'].includes(t.value))
export const typeFaceEnObjs = typeFaceObjs.filter((t) => ['Brush Script MT', 'sans-serif', 'CloisterBlack', 'arriba'].includes(t.value))

export const colorObjs = [
  { label: 'ゴールド', value: 'gold', color: '#D9A948' },
  { label: 'シルバー', value: 'silver', color: '#A7A8A7' },
  { label: 'コルク', value: 'kurk', color: '#A18555' },
  { label: 'チョコレート', value: 'chocolate', color: '#6F4A35' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#FFF059' },
  { label: 'オレンジ', value: 'orange', color: '#CF7D43' },
  { label: 'レッド', value: 'red', color: '#A03D38' },
  { label: 'パープル', value: 'purple', color: '#8200C6' },
  { label: 'ピンク', value: 'pink', color: '#E57780' },
  { label: 'ネイビー', value: 'navy', color: '#2C3F67' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#0096C9' },
  { label: 'グリーン', value: 'green', color: '#719B4F' },
  { label: 'ブルー', value: 'blue', color: '#305173' },
  { label: 'ブラック', value: 'black', color: '#1A1919' },
  { label: 'ホワイト', value: 'white', color: '#F6F3F0' },

  // TODO: 2025/07/12 刺繍提出シートのカラーリストにないので確認
  { label: 'エンジ', value: 'enji', color: '#A8232C' },
  { label: 'グレー', value: 'gray', color: '#7E807F' }
]

export const positionObjs = [
  { label: '親指部分', value: 'thumbFinger', order: 0, isSelectable: true },
  // { label: '中指部分', value: 'middleFinger' },
  // { label: '薬指部分', value: 'ringFinger' },
  { label: '小指部分', value: 'childFinger', order: 3, isSelectable: true },
  { label: '裏革部分(1段目)', value: 'leatherLiningFirst', order: 4, isSelectable: true },
  { label: '裏革部分(2段目)', value: 'leatherLiningSecond', order: 5, isSelectable: true }
]

export const shadowEdgeColorObjs = [{ label: '不要', value: 'none' }, ...colorObjs]
export const pointColorObjs = colorObjs

export const originalEmbroideryObjects = [
  { label: 'オリジナル刺繍あり', value: 'originalEmbroidery', price: 16500 },
  { label: 'なし', value: 'none', price: 0 }
]

export const directLogo1Objects = [
  { label: 'バンド', value: 'band', price: 5500 },
  { label: '中指', value: 'middleFinger', price: 5500 },
  { label: '薬指', value: 'ringFinger', price: 5500 },
  { label: 'なし', value: 'none', price: 0 }
]

export const directLogo2Objects = [
  { label: '裏平', value: 'leatherLiningFirst', price: 5500 },
  { label: '中指', value: 'middleFinger', price: 5500 },
  { label: '薬指', value: 'ringFinger', price: 5500 },
  { label: 'なし', value: 'none', price: 0 }
]
